import { render, staticRenderFns } from "./ProductServiceCheckout.vue?vue&type=template&id=5b903fa8&scoped=true"
import script from "./ProductServiceCheckout.vue?vue&type=script&lang=js"
export * from "./ProductServiceCheckout.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceCheckout.vue?vue&type=style&index=0&id=5b903fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b903fa8",
  null
  
)

export default component.exports